"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  getOffset: function getOffset() {
    var pageNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

    if (limit <= 0 || pageNum <= 0) {
      return 0;
    }

    return Number(pageNum) * Number(limit) - limit;
  },
  getPageNum: function getPageNum() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

    if (Number(offset) <= 0 || Number(limit) <= 0) {
      return 1;
    }

    return Math.ceil(Number(offset) / Number(limit)) + 1;
  },
  getPageCount: function getPageCount() {
    var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

    if (Number(limit) <= 0 || Number(total) <= 0) {
      return 1;
    }

    return Math.ceil(Number(total) / Number(limit));
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/utils/paginationUtils.js
// module id = 596
// module chunks = 25